export function removeEmptyFromObject(obj: { [key: string]: string | number }) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v));
}
